import type { MonitorStage } from "./types";

export function stageLabel(
  stage: MonitorStage,
  label = stage.stage_id,
): string {
  if (stage.stage_id === "assets.provider" && stage.entity_index != null) {
    return `${label} · Scene ${stage.entity_index}`;
  }
  return stage.entity_index == null ? label : `${label} ${stage.entity_index}`;
}
